import React from 'react';
import { Modal, Button, Typography } from '@vtblife/uikit';
import { Size, PhoneInput } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';

import { useRepairUserForm } from '../useRepairUserForm';

import './styles.css';

const cn = classname.bind(null, 'RepairModal');

export const RepairModal = ({
    isRepairModal = false,
    closeRepairModal,
    area
}: {
    isRepairModal: boolean;
    closeRepairModal: () => void;
    area: number;
}) => {
    const {
        isPhoneValid,
        sendRequest,
        meterPrice,
        totalPrice,
        resetForm,
        setPhone,
        isSent,
        phone
    } = useRepairUserForm({ area, place: 'modal' });

    const success = (
        <Typography variant='h3' color='black-500'>
            Заявка принята
        </Typography>
    );

    const closeModal = React.useCallback(() => {
        resetForm();
        closeRepairModal();
    }, [ resetForm, closeRepairModal ]);

    return (
        <Modal opened={isRepairModal} onClose={closeModal}>
            {! isSent ? (<>
                <Modal.Title>
                    Сделайте ремонт через m2.ru
                </Modal.Title>
                <Typography variant='primary' color='black-500'>
                    Предварительная стоимость предчистового ремонта этой квартиры, с&nbsp;учётом черновых материалов
                </Typography>
                <div className={cn('price')}>
                    <Typography color='link-minor' variant='h3'>
                        {`от ${totalPrice} ₽`}
                    </Typography>
                    <Typography color='black-500' variant='h3' className={cn('dot')}>
                        ·
                    </Typography>
                    <Typography color='black-500' variant='h3'>
                        {`${meterPrice} ₽/м²`}
                    </Typography>
                </div>
                <PhoneInput
                    label='Номер телефона'
                    size={Size.Large}
                    value={phone}
                    onChange={setPhone}
                    fullWidth
                    hasClear
                    inputMode='numeric'
                />
                <Typography variant='secondary-alone' color='black-400' className={cn('promo')}>
                    Расчёт опирается на&nbsp;средние цены от&nbsp;партнёров. Стоимость черновых работ посчитана на&nbsp;основе анализа смет.
                </Typography>
                <Button
                    disabled={! isPhoneValid}
                    variant='promo1'
                    onClick={sendRequest}
                    fullWidth
                >
                    Получить полный расчёт
                </Button>
            </>) : success}
        </Modal>
    );
};
